import { useQuery } from "react-query";
import axios from "axios";
import { getUser } from "../../common/helper";

const fetchUserClapCount = async () => {
  const result = {}
  const userId = getUser();
  if(!userId) return {}
  const {
    data: { response },
  } = await axios.get(`https://api.impactrun.com/web/v1/claps/${userId}`);
  if(response?.length) {
    response.forEach((val) => {
      result[val.feed_id] = val.user_clap_count
    })
  }
  return result;
};

export const UserClapCount = () =>
  useQuery("UserClapCount", fetchUserClapCount);
